module.exports = __webpack_public_path__ + "media/images/app-form-sample-7f3ae9b8b38c41af89e00631e45c17b8.png";